<template>
  <div class="card" v-if="loading">
    <div class="card-body">
      <div class="text-center">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>
    </div>
  </div>

  <accordion v-else ref="accordionFiltroProjetosLote">
    <template #header="{ expandido }">
      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center">
        <h4 class="font-size-16 mb-0" style="font-weight: 600;">FILTRO DE PROJETOS DO LOTE N° {{ sqLote }}</h4>
      </div>

      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end align-items-center order-1 order-md-2 mb-2 mb-md-0">
        <i
          :class="expandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'"
          class="icone-accordion"
        ></i>
      </div>
    </template>

    <div class="row d-flex mb-1">
      <div class="col-md-4">
        <b-form-group label="Status">
          <multiselect v-model="selecaoStatusImportacao" :options="selecaoStatusImportacaoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Projeto Unicampo">
          <multiselect v-model="selecaoProjeto" :options="selecaoProjetoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Linha de Crédito">
          <multiselect v-model="selecaoLinhaCredito" :options="linhaCreditoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200"/>
        </b-form-group>
      </div>
    </div>

    <div class="row d-flex mb-1">
      <div class="col-md-4">
        <b-form-group label="Modalidade do Seguro">
          <multiselect v-model="selecaoModalidadeSeguro" :options="selecaoModalidadeSeguroLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Safra">
          <multiselect v-model="selecaoSafra" :options="selecaoSafraLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="200"/>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1">
        <b-button variant="secondary" class="me-md-3 mb-2 mb-md-0" @click="limpar">
          <i class="mdi mdi-broom"></i> Limpar
        </b-button>

        <b-button variant="primary" @click="emitirFiltro" :disabled="disabledFiltro">
          <i class="mdi mdi-filter-outline"></i> Filtrar
          <b-spinner
            variant="secondary"
            small
            class="ms-2"
            v-if="disabledFiltro"
          ></b-spinner>
        </b-button>
      </div>
    </div>
  </accordion>
</template>

<script>
import Multiselect       from "vue-multiselect";
import accordion         from "@/components/accordion";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins    : [clienteRuralMixin],
  components: { Multiselect, accordion},
  props:{
    sqLote: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading                   : true,
      filtroExpandido           : true,
      disabledFiltro            : false,
      selecaoStatusImportacao   : null,
      selecaoProjeto            : null,
      selecaoLinhaCredito       : null,
      selecaoModalidadeSeguro   : null,
      selecaoSafra              : null,
      selecaoStatusImportacaoLkp: [{ name: "INCOMPLETO [I]", value: "I" }, { name: "COMPLETO [C]", value: "C" }, { name: "EXPORTADO [E]", value: "E" }],
      selecaoProjetoLkp         : [],
      selecaoLinhaCreditoLkp    : [],
      selecaoModalidadeSeguroLkp: [],
      selecaoSafraLkp           : [],
    };
  },
  async created(){
    await this.buscarDados();
  },
  methods: {
    async buscarDados() {
      await this.buscarLkpProjeto();
      await this.buscarLkpSafra();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpModalidadeSeguro();

      this.loading = false;
    },
    limpar() {
      this.selecaoStatusImportacao = null;
      this.selecaoProjeto          = null;
      this.selecaoLinhaCredito     = null;
      this.selecaoModalidadeSeguro = null;
      this.selecaoSafra            = null;

      this.$emit('limparGrid');
    },
    emitirFiltro(){
      const filtro = {
        sq_astec_integracao_lote: localStorage.getItem("sqAstecIntegracaoLote") ?  parseInt(localStorage.getItem("sqAstecIntegracaoLote")) : null,
        st_registro             : this.selecaoStatusImportacao?.value           ?? null, 
        sq_tp_projeto           : this.selecaoProjeto?.value                    ?? null, 
        sq_linha_credito        : this.selecaoLinhaCredito?.value               ?? null, 
        sq_modalidade_seguro    : this.selecaoModalidadeSeguro?.value           ?? null, 
        cd_safra                : this.selecaoSafra?.name                       ?? null, 
      }

      this.$emit('filtroPrjetosLote', filtro);
      this.$refs.accordionFiltroProjetosLote.fechar();
    }
  }
};
</script>